import React from 'react';

function WebDesignScrapToDevelopment() {
  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdesign-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="webdesign-scrap-section">
      <div className="container webdesign-scrap-container">
        {/* Left Column: Device Mockup Showcase Image */}
        <div className="webdesign-scrap-left">
          <div className="webdesign-scrap-img-wrapper">
            <img 
              src="/assets/images/web-design/web-img2.jpg" 
              alt="We Design From Scrap To Fully Developed Websites" 
              className="webdesign-scrap-img"
            />
          </div>
        </div>

        {/* Right Column: Text Content */}
        <div className="webdesign-scrap-right">
          <h2 className="webdesign-scrap-title">
            We Design From Scrap To Fully Developed Websites
          </h2>

          <div className="webdesign-scrap-subtitle-box">
            <div className="webdesign-scrap-red-bar"></div>
            <h3 className="webdesign-scrap-subtitle">
              Our Website Designs Don’t Just Look Great—They Work Flawlessly and Drive Results
            </h3>
          </div>

          <p className="webdesign-scrap-desc">
            Your website design should create a powerful impact on the user, as it is the digital storefront of your business. At our website design company, we handle every stage of the process, from initial concept to a fully responsive and functional website that delivers.
          </p>

          <p className="webdesign-scrap-desc">
            Our web design agency focuses on bringing a smooth user experience with a strong back-end system. We want your website to look exceptional and perform extraordinarily. Get a website that actively drives engagement to contribute to your business’s success.
          </p>

          <button className="btn-webdesign-scrap-cta" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
          </button>
        </div>
      </div>
    </section>
  );
}

export default WebDesignScrapToDevelopment;
